'use es6';

import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import I18n from 'I18n';
import Url from 'hubspot.urlinator.Url';
var twitterShareBaseURL = 'https://twitter.com/intent/tweet';
var facebookShareBaseURL = 'http://www.facebook.com/share.php';
var linkedInShareBaseURL = 'https://www.linkedin.com/shareArticle';

var ShareIcons = /*#__PURE__*/function (_React$Component) {
  _inherits(ShareIcons, _React$Component);

  function ShareIcons() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ShareIcons);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ShareIcons)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.getShareText = function () {
      return I18n.text('results.share.shareText');
    };

    _this.getTwitterShareUrl = function (currentUrl) {
      var url = new Url(twitterShareBaseURL);
      url.pushParam('text', _this.getShareText());
      url.pushParam('url', currentUrl);
      url.pushParam('hashtags', I18n.text('results.share.shareHashtag'));
      return url.href;
    };

    _this.getFacebookShareUrl = function (currentUrl) {
      var url = new Url(facebookShareBaseURL);
      url.pushParam('title', _this.getShareText());
      url.pushParam('u', currentUrl);
      return url.href;
    };

    _this.getLinkedInShareUrl = function (currentUrl) {
      var url = new Url(linkedInShareBaseURL);
      url.pushParam('title', _this.getShareText());
      url.pushParam('url', currentUrl);
      url.pushParam('summary', _this.getShareText());
      return url.href;
    };

    return _this;
  }

  _createClass(ShareIcons, [{
    key: "render",
    value: function render() {
      var currentUrl = location.href;
      return /*#__PURE__*/_jsxs("div", {
        className: "share-icons",
        children: [/*#__PURE__*/_jsx("a", {
          className: "icon icon-twitter",
          href: this.getTwitterShareUrl(currentUrl),
          target: "_blank",
          rel: "noopener noreferrer"
        }), /*#__PURE__*/_jsx("a", {
          className: "icon icon-facebook",
          href: this.getFacebookShareUrl(currentUrl),
          target: "_blank",
          rel: "noopener noreferrer"
        }), /*#__PURE__*/_jsx("a", {
          className: "icon icon-linkedin",
          href: this.getLinkedInShareUrl(currentUrl),
          target: "_blank",
          rel: "noopener noreferrer"
        })]
      });
    }
  }]);

  return ShareIcons;
}(React.Component);

export { ShareIcons as default };